<img (click)="activeModal.dismiss('Cross click')" class="ng-element modal-cross" [src]="'/assets/svg/modal-cross.svg'"/>

<h2>Report Comment</h2>
<div class="form-group">
  <label for="flagReason"></label>
  <select class="form-control" id="flagReason" (change)="onFlagReasonChange($event.target.value)">
    <option value="">- Select an Option -</option>
    <option *ngFor="let key of flagReasonKeys" value="{{key}}">{{flagReasons[key]}}</option>
  </select>
</div>
<div class="form-group">
  <textarea class="form-control" placeholder="Your Comment" rows="10" [(ngModel)]="comment" placeholder="Details"></textarea>
</div>

<button type="submit" class="btn notd-primary-btn" [disabled]="!reason || !comment" (click)="reportComment()">Send</button>
